import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: '#9CA3AF',
  backgroundColor: '#F3F4F6',
  fontsize: '14px'
}));

export const GroupItems = styled('ul')({
  padding: 0
});

interface IAutocompleteButtonProps {
  disableNoOption?: boolean;
}

export const StyledAutocompleteFormControl = styled(FormControl)({
  '& .MuiChip-root': {
    borderRadius: 1
  },

  '& .MuiAutocomplete-inputRoot': {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '21px',
    backgroundColor: 'white',
    minHeight: '40px',
    padding: '0 9px !important',
    borderColor: '#E2E2EA',
    paddingRight: '40px'
  },

  '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
    paddingRight: '10px'
  },

  '& fieldset.MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .Mui-focused': {
    '& fieldset.MuiOutlinedInput-notchedOutline': {
      borderColor: '#3959df'
    }
  },

  '& .Mui-disabled': {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    padding: '0px',
    '& .MuiAutocomplete-input': {
      paddingLeft: '14px'
    },
    '& fieldset': {
      borderColor: '#E2E2EA !important'
    }
  },

  // Tag options style
  '& .MuiAutocomplete-tag': {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    background: '#F3F4F6',
    color: '#1F2937',
    borderRadius: '4px',
    height: '24px'
  },

  // Tag options delete icon style
  '& .MuiChip-deleteIcon': {
    color: '#9CA3AF',
    width: '16px',
    height: '16px'
  }
});

export const AutocompleteButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'disableNoOption'
})<IAutocompleteButtonProps>(({ disableNoOption }) => ({
  background: 'none',
  border: 'none',
  color: '#3959df',
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  cursor: 'pointer',
  marginBottom: '8px',
  marginTop: disableNoOption ? '8px' : 'inherit',
  padding: '0 12px'
}));

export const AutocompleteListAction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  paddingTop: '8px'
});

export const AutocompleteLabel = styled('label')({
  display: 'flex',
  alignItems: 'center',
  color: '#7e858e',
  fontSize: '14px',
  fontWeight: 500,
  padding: '4px 0px'
});
